import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {ClientService} from '../services/auth/client.service';
import {ClientStateService} from '../services/auth/client-state.service';
import {ProductType} from '../models/client-options.model';
import {PRODUCT_ORDER, productSlugFromType} from '../shared/products';

@Injectable({
    providedIn: 'root'
})
export class ProductAccessGuard implements CanActivate {
    private readonly clientService = inject(ClientService);
    private readonly router = inject(Router);
    private readonly clientStateService = inject(ClientStateService);

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const targetProduct: unknown = route.data?.['productType'];

        if (!this.isKnownProduct(targetProduct) || !this.clientService.hasProductAccessContext()) {
            this.clientStateService.setClientLoading(false, 'rbac-tenant-denial');
            return false;
        }

        if (this.clientService.canAccessProduct(targetProduct)) {
            this.clientService.setActiveProduct(targetProduct);
            return true;
        }

        const slug = productSlugFromType(targetProduct);
        this.clientService.setActiveProduct(targetProduct);
        this.clientStateService.setClientLoading(false, 'rbac-tenant-denial');
        this.router.navigate(['/products', slug, 'landing'], {queryParams: {from: state.url}})
            .finally(() => this.clientStateService.setClientLoading(false, 'route-loading'));
        return false;
    }

    private isKnownProduct(product: unknown): product is ProductType {
        return typeof product === 'string' && PRODUCT_ORDER.includes(product as ProductType);
    }

}
